import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import { ResetPassword } from 'api/endpoints';
import { useLocation, useNavigate } from 'react-router-dom';

const PasswordResetForm = ({ hasLabel }) => {
  const navigate = useNavigate();
  // State
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });

  const location = useLocation();
  const queryData = location?.search?.split('?')[1]?.split('&');
  const LoginEmail = queryData?.[0]?.split('=')[1];
  const forgotPassKey = queryData?.[1]?.split('=')[1];

  const [loading, setLoading] = useState(false);

  // Handler
  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password === formData.confirmPassword) {
      setLoading(true);

      const finalData = {
        loginId: LoginEmail,
        password: formData.password,
        passwordResetKey: forgotPassKey
      }
      ResetPassword(finalData).then(res => {
        toast.success(`Login with your new password`, {
          theme: "colored",
        });
        setLoading(false);
        navigate("/login");

      }).catch(err => {

        setLoading(false);
        toast.error(err?.message || "Password reset failed.", {
          autoClose: 1000,
        });

      });

    } else {
      toast.error("Confirm password does not match", {
        autoClose: 1000,
      });
    }


  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form
      className={classNames('mt-3', { 'text-left': hasLabel })}
      onSubmit={handleSubmit}
    >
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>New Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'New Password' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Confirm Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Confirm Password' : ''}
          value={formData.confirmPassword}
          name="confirmPassword"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Button
        type="submit"
        className="w-100"
        disabled={!formData.password || !formData.confirmPassword || loading}
      >
        Set password{loading && '...'}
      </Button>
    </Form>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default PasswordResetForm;
